import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from '../../common/CloseIcon';
import LandingPageMenu from '../../LandingPageMenu/LandingPageMenu';

type LandingMenuModalProps = {
  onFeedbackClick: () => void;
  onClose: () => void;
  sheetRef?: React.RefObject<HTMLDivElement>;
};

/**
 * The landing-page header menu, rendered through the shared modal stack
 * (ModalOutlet), which layers it above the building/profile modals (its
 * z-index override is 2510). `sheetRef` is forwarded so the host's
 * outside-click-to-close detection still works wherever the outlet mounts it.
 * `onFeedbackClick` hands Send Feedback to the host, which owns the modal.
 */
const LandingMenuModal: React.FC<LandingMenuModalProps> = ({
  onFeedbackClick,
  onClose,
  sheetRef,
}) => {
  const { t } = useTranslation();
  return (
    <div className="new-landing-page__mobile-menu-sheet" ref={sheetRef}>
      <div className="new-landing-page__mobile-menu-header">
        <div className="new-landing-page__mobile-menu-spacer" />
        <div className="new-landing-page__mobile-menu-title">
          {t('newLandingPage.menu.title')}
        </div>
        <button
          aria-label={t('newLandingPage.menu.closeAria')}
          className="new-landing-page__mobile-menu-close"
          onClick={onClose}
          type="button"
        >
          <CloseIcon size={18} color="#1A1A1A" />
        </button>
      </div>

      <div className="new-landing-page__mobile-menu-body">
        <LandingPageMenu
          onFeedbackClick={onFeedbackClick}
          variant="newLandingMobile"
        />
      </div>
    </div>
  );
};

export default LandingMenuModal;
